import { EUserPermissions } from '@zunta/configurations'

const meta = {
  requiresAuth: true,
  managementOnly: true
}

export default [
  {
    path: 'settings',
    name: 'management-settings',
    meta,
    component: () => import('@/views/app/management/settings/Settings.vue'),
    redirect: { name: 'management-facilities' },
    children: [
      {
        path: 'hmos',
        name: 'management-hmos',
        meta,
        component: () => import('@/views/app/management/settings/pages/Hmos.vue')
      },
      {
        name: 'management-facilities',
        path: 'facilities',
        meta,
        component: () => import('@/views/app/management/settings/pages/Facilities.vue')
      },
      // facility pages
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES] },
        name: 'management-facilities-settings-information',
        path: 'facility/:id',
        component: () => import('@/views/app/management/settings/pages/facility/information/FacilityInfo.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.VIEW_FACILITY_FEES] },
        name: 'management-facility-billing',
        path: 'facility/:id/billing',
        component: () => import('@/views/app/management/settings/pages/facility/billing/FacilityBillingSettings.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.EDIT_FACILITY_ADVANCED_SETTINGS] },
        name: 'management-facilities-settings-batch',
        path: 'facility/:id/batch',
        component: () => import('@/views/app/management/settings/pages/facility/batch/FacilityBatchSettings.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.VIEW_COLLECTIONS_FLOW] },
        name: 'management-facilities-settings-collections-management',
        path: 'facility/:id/collections',
        component: () => import('@/views/app/management/settings/pages/facility/collections/FacilityCollectionsManagement.vue')
      },
      {
        meta: {
          ...meta,
          permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.VIEW_PAYMENT_ACCOUNT_AND_PAY_SETTINGS]
        },
        name: 'management-facilities-settings-payment-settings',
        path: 'facility/:id/payment',
        component: () => import('@/views/app/management/settings/pages/facility/payment/FacilityPaymentSettingsV2.vue')
      },
      {
        meta: {
          ...meta,
          permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.VIEW_PAYMENT_ACCOUNT_AND_PAY_SETTINGS, EUserPermissions.CONFIGURE_PAYMENTS_ACCOUNTS]
        },
        name: 'management-facilities-settings-payment-settings-configure',
        path: 'facility/:id/payment/settings',
        component: () => import('@/views/app/management/settings/pages/facility/payment/components/FacilityPaymentSettingsConfigureV2.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.MODIFY_PAYER_TYPES] },
        name: 'management-facilities-settings-payers',
        path: 'facility/:id/payers',
        component: () => import('@/views/app/management/settings/pages/facility/payers/FacilitySettingsPayerTypes.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES] },
        name: 'management-facilities-settings-claim-flow',
        path: 'facility/:id/claim-flow',
        component: () => import('@/views/app/management/settings/pages/facility/claim-flow/ClaimFlow.vue')
      },
      {
        meta: { ...meta, permissions: [EUserPermissions.VIEW_FACILITIES] },
        name: 'management-facilities-settings-create-claim-flow',
        path: 'facility/:id/claim-flow/:claimFlowId?',
        component: () => import('@/views/app/management/settings/pages/facility/claim-flow/CreateClaimFlow.vue')
      },
      {
        meta: {
          ...meta,
          permissions: [EUserPermissions.VIEW_FACILITIES, EUserPermissions.VIEW_COLLECTIONS_FLOW, EUserPermissions.MODIFY_COLLECTIONS_FLOW]
        },
        name: 'management-facilities-create-billing-flow',
        path: 'facility/:id/collections/:collectionFlowId',
        component: () => import('@/views/app/management/settings/pages/facility/billing/CreateBillingFlow.vue')
      },
      // end facility pages
      {
        path: 'users',
        name: 'management-users',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_USERS] },
        component: () => import('@/views/app/management/settings/pages/Users.vue')
      },
      {
        path: 'users/:userId',
        name: 'management-users-edit',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_USERS] },
        component: () => import('@/views/app/management/users/UserV2.vue')
      },
      {
        path: 'permissions',
        name: 'management-users-permissions',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_PERMISSIONS] },
        component: () => import('@/views/app/management/settings/pages/Permissions.vue')
      },
      {
        path: 'templates',
        name: 'management-templates',
        meta: { ...meta, permissions: [EUserPermissions.VIEW_TEMPLATES] },
        component: () => import('@/views/app/management/settings/pages/Templates.vue')
      }
    ]
  },
  {
    name: 'management-template',
    meta: { ...meta, permissions: [EUserPermissions.VIEW_TEMPLATES] },
    path: 'settings/templates/:templateId',
    component: () => import('@/views/app/management/settings/pages/SetupTemplate.vue')
  }
]
